// Cookie consent (`partials/cookie-banner.hbs`). Analytics run in Google's consent mode, denied until the visitor accepts.

import {readStorage, writeStorage} from '../lib/storage.ts'

/** Local storage key of the consent. `default-app.hbs` sets it for app users, who accept our terms in the app. */
const COOKIES_ACCEPTED_KEY = 'cookies-accepted'

/** Whether the visitor accepted cookies in the cookie banner (or uses the app) */
export function cookiesAccepted() {
    return readStorage(COOKIES_ACCEPTED_KEY) === 'true'
}

/** Shows the cookie banner, unless accepted before, and grants analytics consent once accepted */
export function initCookieBanner() {
    const banner = document.getElementById('cookieBanner')
    if (!banner) return

    // held back so the hero gets to make its case first; consent is denied by default, so nothing is tracked while it waits
    if (!cookiesAccepted()) setTimeout(() => banner.classList.add('active'), 5000)

    document.getElementById('acceptCookies')?.addEventListener('click', () => {
        banner.classList.remove('active')
        writeStorage(COOKIES_ACCEPTED_KEY, 'true')
        window.gtag?.('consent', 'update', { // undefined if initAnalytics() failed
            ad_user_data: 'granted',
            ad_personalization: 'granted',
            ad_storage: 'granted',
            analytics_storage: 'granted'
        })
    })
}
